var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import DepositMoney from '../account/subpages/financialTransactions/deposit.money';
import { betSlipVisiblity } from "../../shared/betslip/betslip";
export default function DepositMoneys() {
    return (_jsx("div", __assign({ style: { width: (betSlipVisiblity ? 'calc(100% - 300px)' : '100%') } }, { children: _jsx(DepositMoney, {}, void 0) }), void 0));
}
